import React from 'react';
import { Table } from 'antd';

const SupplierPerformanceSuppliersPanel = ({
	panelRows,
	supplierTableColumns,
	scrollY,
	onRowHover,
	onRowLeave,
	onRowClick,
	highlightedSupplierId,
}) => {
	return (
		<Table
			className="w-full [&_.ant-table-row]:cursor-pointer [&_.supplier-row-highlighted>td]:!bg-table-hover"
			columns={supplierTableColumns}
			rowKey={(row) => `${row.supplierFacilityId}`}
			pagination={false}
			size="small"
			scroll={{ y: scrollY || 530 }}
			dataSource={panelRows}
			onRow={(record) => ({
				className:
					highlightedSupplierId != null && record.supplierFacilityId === highlightedSupplierId
						? 'supplier-row-highlighted'
						: undefined,
				onMouseEnter: () => onRowHover && onRowHover(record),
				onMouseLeave: () => onRowLeave && onRowLeave(),
				onClick: () => onRowClick && onRowClick(record),
			})}
		/>
	);
};

export default SupplierPerformanceSuppliersPanel;
